import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Layout } from './components/Layout';
import { Dashboard } from './pages/Dashboard';
import { PlatformsList } from './pages/PlatformsList';
import { CreatePlatform } from './pages/CreatePlatform';
import { Settings } from './pages/Settings';

// Create a client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 5000,
    },
  },
});

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<Dashboard />} />
            <Route path="platforms" element={<PlatformsList />} />
            <Route path="settings" element={<Settings />} />
            {/* Platform creation wizard */}
            <Route path="platforms/new" element={<CreatePlatform />} />
            <Route
              path="platforms/:id"
              element={
                <div className="text-center py-12">
                  <h2 className="text-2xl font-bold text-gray-900 mb-4">
                    Platform Details
                  </h2>
                  <p className="text-gray-600">
                    This feature is coming soon. The backend endpoint needs to be
                    implemented first.
                  </p>
                </div>
              }
            />
          </Route>
        </Routes>
      </BrowserRouter>
    </QueryClientProvider>
  );
}

export default App;
